import * as React from 'react';
import * as classNames from 'classnames';

/**
 * @overview Loader component
 *
 * All loaders should be rendered by this component,
 * due to consistency
 */

interface ILoaderProps {
  className?: string;
  modifier?: string;
  white?: boolean;
  inline?: boolean;
  block?: boolean;
  center?: boolean;
}

// style declaration
import './style.sass';

export const Loader: React.StatelessComponent<ILoaderProps> =
(props: ILoaderProps) => {
  const {className = '', white = false, inline = false, center = false, block = false} = props;

  const loaderClassName = classNames('loader-component', className, {
    'loader-component_block': block,
    'loader-component_white': white,
    'loader-component_inline': inline,
    'loader-component_center': center,
  });

  return (
    <div className={loaderClassName}></div>
  );
};
